import { ToastrService } from 'ngx-toastr';
import { Injectable } from '@angular/core';
import { PageOptions } from 'src/app/shared/data-table/data-table.interface';
import { config } from 'src/config/config';
import { BaseHttpService } from 'src/app/shared/base-http/base-http.service';
import { FileDownloadService } from 'src/app/shared/file-download/file-download.service';
import { getEnv } from 'src/modules/utility';
import { finalize } from 'rxjs/operators';
import { CgpSnackbarService } from 'src/app/shared/cgp-snackbar/cgp-snackbar.service';

@Injectable({
  providedIn: 'root'
})
export class FileUploadSummaryService {

  constructor(
    private readonly http: BaseHttpService,
    private readonly download: FileDownloadService,
    private readonly toastr: ToastrService,
    private readonly snackbar: CgpSnackbarService
  ) { }

  getFileUploadSummary(pageOptions?: PageOptions) {
    pageOptions = pageOptions || {
      page: 0,
      order: 'asc',
      size: 10,
      sort: 'programName',
    };

    const url = `${config.tprecmApiBaseUrl[getEnv()]}report/file-upload-summary`
      + `?page=${pageOptions.page}&size=${pageOptions.size}&sort=${pageOptions.sort}&order=${pageOptions.order}`;
    return this.http.get(url);
  }

  exportExcel(options: any = {}) {

    const ref = this.snackbar.showSnackbar({
      message: 'Downloading Attachment...',
      action: 'Dismiss',
      duration: null
    });

    const url = `${config.tprecmApiBaseUrl[getEnv()]}report/file-upload-summary/download`;
    this.http.get(url, options)
      .pipe(finalize(() => ref.dismiss()))
      .subscribe(
        (res) => {
          if (res && res.data) {
            const date = new Date();
            const filename = `FileUploadSummary_${date.getFullYear()}${date.getMonth() + 1}${date.getDate()}_${date.getHours()}${date.getMinutes()}${date.getSeconds()}.xlsx`;
            this.download.downloadBlob(filename, this.download.b642Blob(res.data, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'));
          } else {
            this.toastr.error('An Error Occured, please try again.', 'Download failed.');
          }
        }
      );
  }
}
